import { useEffect, useLayoutEffect, useState, type RefObject } from 'react';

/**
 * Шапка в ОДНУ строку на любой ширине компьютера (header1, макет Юрия 04.10.2026).
 *
 * Текст не уменьшается: когда ряд не помещается, второстепенное по шагам
 * сворачивается — слово логотипа, «Отложено» и «Непрочитано» (они остаются в
 * меню «Переписки ▾»), длинная подпись подключения, подписи у значков. Шаги
 * описаны в `phone-pult.css` классами `hdr-l1`…`hdr-l{MAX}`.
 *
 * Мера — правый край последнего видимого пункта против края строки. Шаг
 * подбирается до отрисовки (layout-эффект), поэтому мигания нет. Ширина или
 * состав пунктов поменялись — подбор заново с нуля; поменялось только число
 * внутри пункта — проверяется лишь, не стало ли тесно.
 */
export const SZHATIE_MAX = 11;

function tesno(row: HTMLElement): boolean {
  if (window.innerWidth < 768) return false;
  const box = row.getBoundingClientRect();
  const pad = parseFloat(getComputedStyle(row).paddingRight) || 0;
  let right = 0;
  row.querySelectorAll<HTMLElement>('.hdr-item').forEach((el) => {
    if (el.offsetParent === null) return;
    right = Math.max(right, el.getBoundingClientRect().right);
  });
  return right > box.right - pad + 0.5;
}

export function useSzhatieShapki(ref: RefObject<HTMLElement | null>): number {
  const [uroven, setUroven] = useState(0);
  const [takt, setTakt] = useState(0);

  useLayoutEffect(() => {
    const row = ref.current;
    if (row && uroven < SZHATIE_MAX && tesno(row)) setUroven(uroven + 1);
  }, [ref, uroven, takt]);

  useEffect(() => {
    const row = ref.current;
    if (!row) return;
    let width = row.getBoundingClientRect().width;
    const sNulya = () => { setUroven(0); setTakt((n) => n + 1); };
    const resize = new ResizeObserver(() => {
      const next = row.getBoundingClientRect().width;
      if (Math.abs(next - width) > 0.5) { width = next; sNulya(); }
    });
    resize.observe(row);
    const sostav = new MutationObserver((list) => {
      if (list.some((m) => m.type === 'childList')) sNulya();
      else if (tesno(row)) setTakt((n) => n + 1);
    });
    sostav.observe(row, { childList: true, subtree: true, characterData: true });
    // Поздний шрифт меняет ширину слов без перемены состава и ширины строки.
    const fonts = document.fonts;
    void fonts?.ready.then(sNulya);
    fonts?.addEventListener?.('loadingdone', sNulya);
    return () => { resize.disconnect(); sostav.disconnect(); fonts?.removeEventListener?.('loadingdone', sNulya); };
  }, [ref]);

  return uroven;
}
